import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils';
// import Mine from '../views/MineView/Mine'


const LoginFirtst = () => import('views/GaoBaoBan/login/LoginFirtst')
const PhoneCodeLogin = () => import('views/GaoBaoBan/login/PhoneCodeLogin')
const accountPasswordLogin = () => import('views/GaoBaoBan/login/AccountPasswordLogin')
const accountRegister = () => import('views/GaoBaoBan/login/AccountRegister')
const loginSwitch = () => import('views/GaoBaoBan/login/LoginSwitch')
const autoLogin = () => import('views/GaoBaoBan/login/AutoLogin')


const RealName = () => import('views/GaoBaoBan/userCenter/RealName')
const AccountSafe = () => import('views/GaoBaoBan/userCenter/AccountSafe')
const ChangePsw = () => import('views/GaoBaoBan/userCenter/ChangePsw')
// const ChangePsw = () => import('views/GaoBaoBan/userCenter/ChangePsw')
Vue.use(Router)


let routes = [
  {
    path: "/loginFirst",
    component: LoginFirtst
  },
  {
    path: "/phoneCodeLogin",
    component: PhoneCodeLogin
  },
  {
    path: "/accountPasswordLogin",
    component: accountPasswordLogin
  },
  {
    path: "/accountRegister",
    component: accountRegister
  },
  {
    path: "/loginSwitch",
    component: loginSwitch
  },
  {
    path: "/autoLogin",
    component: autoLogin
  },
  {
    path: "/realName",
    component: RealName
  },
  {
    path: "/accountSafe",
    component: AccountSafe
  },
  {
    path: "/changePsw",
    component: ChangePsw
  },
]

let type = utils.getUrlKey("type")
if ("gaoBaoBanLogin" === type) {
  // console.log("显示高爆版页面");
  let param = utils.getUrlKey("param")
  let savingAccounts = JSON.parse(param)['savingAccounts']
  // console.log(savingAccounts);
  if (savingAccounts !== undefined && savingAccounts.indexOf("username") !== -1) {
    let haveAutoLoginAccount = false;
    savingAccounts = JSON.parse(savingAccounts);
    // 判断所有账号是不是有自动登录的，有就要将默认启动页面设置为自动登录的
    for (let index = 0; index < savingAccounts.length; index++) {
      const accountJson = savingAccounts[index];
      let autoLogin = accountJson['autoLogin'];
      if ("true" === autoLogin) {
        haveAutoLoginAccount = true;
        break;
      }
    }
    if (haveAutoLoginAccount) {
      routes.push(
        {
          path:"/index.html",
          redirect: "/autoLogin"
        },
      );
      routes.push(
        {
          path:"/",
          redirect: "/autoLogin"
        },
      );
    }else {
      routes.push(
        {
          path:"/index.html",
          redirect: "/loginSwitch"
        },
      );
      routes.push(
        {
          path:"/",
          redirect: "/loginSwitch"
        },
      );
    }
  }else{
    routes.push(
      {
        path:"/index.html",
        redirect: "/loginFirst"
      },
    );
    routes.push(
      {
        path:"/",
        redirect: "/loginFirst"
      },
    );
  }
}else if ("gaoBaoBanCenter" === type) {
  // routes.push(
  //   {
  //     path:"/index.html",
  //     redirect: "/userCenter"
  //   },
  // );
  // routes.push(
  //   {
  //     path:"/",
  //     redirect: "/userCenter"
  //   },
  // );
}



export default new Router({
  routes,
  // mode: 'history',// 模式，避免地址栏显示多余的#
  linkActiveClass: "router-active" //当前选中的 router-link 的class的值，可以用于在style中设置这个class name,展示不同的选中状态
})



// WEBPACK FOOTER //
// ./src/gaoBaoBan/router/index.js